<template>
<div class="page_order page">
    <van-tabs v-model="active" swipe-threshold="6" @click="onTabsClick">
        <van-tab title="全部" :name="0"></van-tab>
        <van-tab title="待支付" :name="1"></van-tab>
        <van-tab title="待发货" :name="2"></van-tab>
        <van-tab title="待收货" :name="3"></van-tab>
        <van-tab title="待评价" :name="4"></van-tab>
        <!-- <van-tab title="售后" ></van-tab> -->
    </van-tabs>
    <!-- <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
    </van-list> -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
            <div class="list">
                <div class="item" v-for="(order,index) in orderList" :key="index">
                    <div class="item_t">
                        <div class="item_t_t" v-if="!order.company_id">
                            <img :src="order.tradesman_thumb ? ( $publicData.withHttpStart(order.tradesman_thumb) ? order.tradesman_thumb :imageUrl+order.tradesman_thumb ) : $publicData.defaultTouxiang" alt="" class="thumb">
                            <div class="title">{{ order.tradesman_name }}</div>
                        </div>
						<div class="item_t_t" v-if="order.company_id">
                            <img :src="order.company_thumb ? order.company_thumb : $publicData.defaultTouxiang" alt="" class="thumb">
                            <div class="title">{{ order.company_name }}</div>
                        </div>
                        <div class="status">{{ order.statusTitle }}</div>
                    </div>
                    <div class="item_nr" v-for=" (goods,index) in order.order_good" :key="index" @click="goOrderDetail(order)">
                        <div :class="goods.is_blockchain ? 'item_nr_l blockchain' : 'item_nr_l'" v-if="!order.company_id">
                            <img :src="goods.thumb ? imageUrl+goods.thumb: $publicData.intangibleDefault" alt="" class="tu">
                        </div>
						<div class="item_nr_l" v-if="order.company_id">
                            <img :src="goods.thumb ? goods.thumb: $publicData.intangibleDefault" alt="" class="tu">
                        </div>
                        <div class="item_nr_r">
                            <div class="item_nr_r_t">
                                <div class="title slh">{{ goods.title }}</div>
                                <div class="info">
                                    <span class="price"><span class="tag_cash">¥</span>{{ goods.price }}</span>
                                    <span class="nums">x{{ goods.num }}</span>
                                </div>
                            </div>
                            <div class="sku">{{ goods.spec_name }}</div>
                        </div>
                    </div>
                    <div class="item_b">
                        <div class="sum" v-if="order.discount">折扣: <span class="sum_r">{{ order.dazhe }}</span></div>
                        <div class="sum">共{{ order.nums }}件商品<span class="sum_r">合计：¥ <span class="total_price">{{ order.total_prices }}</span></span></div>
                        <div class="actions">
                            <!-- <div class="action" style="cursor: pointer" @click="goOrderDetail(order)">查看详情</div> -->
                            <div class="action" v-if="(order.order_status!=0&&order.pay_status==0) || (order.order_status!=0&&order.pay_status==1)" @click="toPay(order)">付款</div>
						</div>
                    </div>
                </div>
            </div>
        </van-list>
    </van-pull-refresh>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../../.././vuex/mutation_types";
import Bridge from '../../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            active: 0,
            orderList: [],
            token: '',
            finished: false,
            page: 1,
            size: 10,
            loading: false,
            refreshing: false,
            goNext: false
        };
    },
    created: function () {
		
    },
    mounted: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '订单列表',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.onRefresh()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.onRefresh()
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            // 获取列表
            // this.onRefresh();
        }

    },
	// 被 keep-alive 缓存的组件激活时调用
    activated() {
		// console.log('activated',this.active)
		// if(localStorage.getItem('orderStatus') != null){
		// 	this.active = parseInt(localStorage.getItem('orderStatus'))
		// }else if(this.$route.query.status != null){
		// 	this.active = parseInt(this.$route.query.status)
		// }
		// if (this.goNext) {
		// 	this.goNext = false
		// } else {
		// 	this.token = this.$store.getters.token
		// 	this.onRefresh();
		// }
	},
	beforeRouteEnter(to, from, next){
		// console.log('进入to===',to)
		to.meta.keepAlive = true;
		next(vm=>{
			if(vm.$route.meta.isrefer){
				console.log('要刷新');
				vm.active = parseInt(vm.$route.query.status)
				vm.token = vm.$store.getters.token
				vm.orderList = [];
				vm.onRefresh();
			}else{
				console.log('不要刷新')
			}
		})
	},
	beforeRouteLeave(to, from, next){
		to.query.status = this.active;
		next();
	},
    methods: {
        onTabsClick(name, title) {
            this.active = name
            this.onRefresh()
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.page = 1
            this.getData();
        },
        // 获取列表
        getData() {
            if (this.token == null || this.token == undefined || this.token == '') {
                return
            }
            var params = {
                token: this.token,
                status: this.active,
                page: this.page,
                size: this.size
            }
            this.$api.shop.orderList(params).then(res => {
                if (res.code == 200) {
                    var list = res.result.list
                    for (let i = 0; i < list.length; i++) {
                        var order = list[i];
                        // 订单折扣
                        var discount = order.discount
                        if (discount && discount != 0) {
                            var discount = discount.toString()
                            var zhe = ''
                            if (discount.length == 1) {
                                zhe = discount / 10 + '折'
                            } else if (discount.length > 1) {
                                if (discount[discount.length - 1] == 0) {
                                    zhe = discount / 10 + '折'
                                } else {
                                    zhe = discount + '折'
                                }
                            }
                            order.dazhe = zhe
                        }
                        // 订单状态 0关闭 1正常 2完成 3退款中
                        if (order.order_status == 0) {
							if(order.pay_status == 2){
								order.statusTitle = '已退款'	
							}else{
								order.statusTitle = '已取消'
							}
                        } else if (order.receipt_status == 1) {
                            // order.statusTitle = '已收货'
                            order.statusTitle = '交易成功'
                        } else if (order.order_status == 3) {
                            order.statusTitle = '退款中'
                        }else {
                            if (order.ship_status == 1) {
                                // order.statusTitle = '已发货'
                                order.statusTitle = '等待收货'
                            } else {
                                if (order.pay_status == 0) {
                                    // order.statusTitle = '未支付'
                                    order.statusTitle = '等待付款'
                                } else if (order.pay_status == 1) {
                                    // order.statusTitle = '支付中'
                                    order.statusTitle = '等待付款'
                                } else if (order.pay_status == 2) {
                                    // order.statusTitle = '已支付'
                                    order.statusTitle = '等待发货'
                                }
                            }
                        }
                    }
                    if (this.page == 1) {
                        this.orderList = list
                    } else {
                        var old = this.orderList
                        for (let i = 0; i < list.length; i++) {
                            old.push(list[i])
                        }
                        this.orderList = old
                    }
                    if (list.length < this.size) {
                        // 数据全部加载完
                        this.finished = true
                        this.refreshing = false
                        return;
                    }
                    // console.log('list', list)
                } else {
                    this.finished = true
                    this.$toast(res.message)
                }
                this.page++;
                this.refreshing = false
                this.loading = false;
            })
        },
        // 订单详情
        goOrderDetail(order) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var p = "?orderId=" + order.order_id
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/order/detail' + p
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                console.log('this.role', this.role)
                this.goNext = true
                this.$router.push({
                    path: '/order/detail',
                    query: {
                        orderId: order.order_id
                    }
                })
			}
			// localStorage.setItem('orderStatus',this.active)
        },
        toPay(order) {
			// 无需查实际支付金额，未支付和支付失败的，都不会扣钱 20230513改动
			if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
				var p = "?orderId=" + order.pay_order_num + '&price=' + order.total_prices + '&sorce=' + order.is_cloud + '&park_point=' + order.user_park_point + '&duihuan_money=' + order.user_duihuan_money + '&pay_status=' + order.pay_status + '&park_uuid=' + order.park_uuid
				var params = {
					'data': {
						'url': this.$publicData.clientUrl + '/shop/pay' + p
					}
				}
				this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
			} else {
				this.goNext = true
				this.$router.push({
					path: '/shop/pay',
					query: {
						orderId: order.pay_order_num,
						price: order.total_prices,
						isPlatprice: order.company_id ? 1 : order.is_platprice,
						sorce: order.is_cloud,
						park_point: order.user_park_point,
						duihuan_money: order.user_duihuan_money,
						pay_status: order.pay_status,
						park_uuid: order.park_uuid,
						thirdJifenBili: order.score_rule
					}
				})
			}
            // 先查一下实际支付金额
            // var shifuPrice = order.total_prices
            // var params = {
            //     token: this.token,
            //     pay_order_num: order.pay_order_num
            // }
            // this.$api.shop.paymoney(params).then(res => {
            //     if (res.code == 200) {
            //         var dikou = res.result
			// 		shifuPrice = (order.total_prices - dikou.chargecard - dikou.user_money - dikou.parkscore_money).toFixed(2)
			// 		// 带着实际支付金额, 跳到支付页面
            //         if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //             var p = "?orderId=" + order.pay_order_num + '&price=' + shifuPrice + '&sorce=' + order.is_cloud + '&park_point=' + order.user_park_point + '&duihuan_money=' + order.user_duihuan_money + '&pay_status=' + order.pay_status + '&park_uuid=' + order.park_uuid
            //             var params = {
            //                 'data': {
            //                     'url': this.$publicData.clientUrl + '/shop/pay' + p
            //                 }
            //             }
            //             this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

            //             })
            //         } else {
            //             this.goNext = true
            //             this.$router.push({
            //                 path: '/shop/pay',
            //                 query: {
            //                     orderId: order.pay_order_num,
            //                     price: shifuPrice,
            //                     isPlatprice: order.is_platprice,
            //                     sorce: order.is_cloud,
            //                     park_point: order.user_park_point,
            //                     duihuan_money: order.user_duihuan_money,
			// 					pay_status: order.pay_status,
			// 					park_uuid: order.park_uuid
            //                 }
            //             })
            //         }
            //     }
            // })
            // console.log('shifuPrice', shifuPrice)

        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
